// extracted by css-extract-rspack-plugin
export default {"flexLayout":"flexLayout-NO898T","navbarList":"navbarList-mwYzur","footer":"footer-B3Gzf4","headerRoot":"headerRoot-jhnnbo"};